import { makeStyles } from '@bymason-private/controller-v1-theme-provider';
import { LinkCard } from '@bymason-private/legacy-pattern-components';

const useStyles = makeStyles(() => ({
  sectionEmpty: { width: '100%', paddingTop: 40, display: 'flex', justifyContent: 'center' },
}));

export default function NoArtifacts() {
  const classes = useStyles();

  return (
    <div className={classes.sectionEmpty}>
      <LinkCard
        message='View documentation'
        Component={
          <img
            src='https://mcdn.bymason.com/runway/controller/empty-state-docs.svg'
            alt='Visit our documentation site'
          />
        }
        href='https://docs.bymason.com/platform/cli#mason-register'
        target='_blank'
        rel='noopener noreferrer'
      />
    </div>
  );
}
